import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { CallbackFormInterface } from "../../interfaces/callback-form-interface";
import { CommonFormService } from '../common-form/common-form.service';

export interface FormPayload {
  name: string;
  phone: string;
  email: string;
  message: string;
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class CallbackFormService {

  constructor(private readonly http: HttpClient, private readonly commonFormService: CommonFormService) {
  }

  processForm(payload: FormPayload): Observable<CallbackFormInterface> {

    const formPayload = {
      form: {
        data: {
          name: payload.name,
          phone: payload.phone,
          email: payload.email,
          message: payload.message
        },
        code: payload.code
      }
    };

    return this.http.post<CallbackFormInterface>(
      this.commonFormService.WEB_ORDER_URL,
      formPayload
    )
  }
}
